import { Box, Button, Divider, Typography } from "@mui/material";
import { IOperation } from "Models/Operation";
import { useNavigate } from "react-router-dom";
import { setCurrentOperation, setDocumentTypeName } from "redux/features/operationSlice";
import { useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useGetAllDocumentTypesQuery } from "redux/api/documentTypeApi";

export const PendantOperation = ({ operation }: { operation: IOperation }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate(); // Hook de navegación
    const { formatMessage } = useIntl();
    const { data: documentTypes = [] } = useGetAllDocumentTypesQuery();
    const documentTypeName = documentTypes.find((type: { _id: string; name: string }) => type._id === operation?.documentTypeId)?.name || 'Desconocido';
    const continueOperation = async () => {
        if (operation) {
            dispatch(setCurrentOperation(operation))
            dispatch(setDocumentTypeName(documentTypeName));
            navigate("/");
        }
    };
    
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
                marginBottom: "20px", // Se agrega separación inferior entre las cards
            }}
        >
            <Box
                sx={{
                    border: "2px solid black",
                    padding: "20px",
                    width: "300px",
                    borderRadius: "3px",
                    fontFamily: "Arial, sans-serif",
                    backgroundColor: "#f2f2f2",
                    position: "relative",
                }}
            >
                <Typography sx={{ marginBottom: "8px" }}>
                    <strong>{formatMessage({ id: "pendant.operation.name" })}</strong> {operation?.clientName}
                </Typography>
                <Divider sx={{ margin: "8px 0" }} />
                <Typography sx={{ marginBottom: "8px" }}>
                    <strong>{formatMessage({ id: "pendant.operation.name" })}</strong> {operation?.id}
                </Typography>
                <Divider sx={{ margin: "8px 0" }} />
                <Typography sx={{ marginBottom: "8px" }}>
                    <strong>{formatMessage({ id: "pendant.operation.name" })}</strong> {operation?.amount}€
                </Typography>
                <Divider sx={{ margin: "8px 0" }} />
            </Box>
            <Button
                variant="contained"
                color="secondary"
                onClick={continueOperation}
                sx={{
                    position: "absolute",
                    bottom: "-10px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    padding: "5px 20px",
                    whiteSpace: "nowrap",
                }}
            >
                {formatMessage({ id: "buttons.continue" })}
            </Button>
        </Box>
    );
};